<template>
  <div class="home">
    <header v-if="isShow">
      <div class="page header">
        <div class="title flex">
          <img src="@/static/imgs/logo.png" alt="" /> 靓号帮
        </div>
        <!-- <div class="flex">
          <div class="tabs" v-for="(i, v) in tabList" :key="v">{{ i }}</div>
        </div> -->
        <el-tabs
          v-model="activeName"
          class="demo-tabs"
          @tab-click="handleClick($event)"
        >
          <el-tab-pane
            v-for="(i, v) in tabList"
            :label="i"
            :name="i"
            :key="v"
          ></el-tab-pane>
        </el-tabs>
      </div>
    </header>
    <!-- <keep-alive> </keep-alive> -->
    <router-view />
  </div>
</template>
<script setup>
import { ref, reactive, watch, onBeforeUnmount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const isShow = ref(true);
const router = useRouter();
const activeName = ref("首页");

// console.log(router.currentRoute._value.fullPath);
const path = ref("");

const tabList = reactive([
  "首页",
  "关于我们",
  "公司优势",
  "核心业务",
  "APP介绍",
  "新闻资讯",
  "联系我们",
]);

const handleClick = (e) => {
  activeName.value = e.props.name;
  store.commit("changeTabs", e.props.name);
  if (activeName.value == "关于我们") {
    router.push("/about");
  } else if (activeName.value == "首页") {
    router.push("/");
  } else if (activeName.value == "APP介绍") {
    router.push("/app");
  } else if (activeName.value == "联系我们") {
    router.push("/contact");
  } else if (activeName.value == "公司优势") {
    router.push("/company");
  } else if (activeName.value == "核心业务") {
    router.push("/business");
  } else if (activeName.value == "新闻资讯") {
    router.push("/news");
  }
};
watch(activeName, (newValue, oldValue) => {
  // activeName.value = store.state.activeName.toString();
});
const states = reactive({
  timer: "", //定时器
});

onMounted(() => {
  setTimer(); // 设置定时器
});
// 设置定时器
const setTimer = () => {
  // 注意: setInterval()第一个参数为方法名的时候，不要加括号;
  states.timer = setInterval(setLockStatus, 1000); // 设置每秒执行一次setLockStatus
};

// 定时器触发后的事件
const setLockStatus = () => {
  // 功能代码
  if (store.state.activeName) {
    activeName.value = store.state.activeName;
  }

  if (activeName.value == "首页") {
    router.push("/");
  }
  path.value = router.currentRoute._value.fullPath;

  if (path.value.indexOf("detail") != -1) {
    isShow.value = false;
  } else {
    isShow.value = true;
  }
};

// 清除定时器
const clearTimer = () => {
  clearInterval(states.timer);
};
onBeforeUnmount(() => {
  console.log("组件卸载之后（生命周期钩子）");
  clearTimer();
});
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  overflow-x: hidden;
}
.home {
  width: 10rem;
  font-family: "PingFangMedium";
}
.page {
  width: 6.25rem;
  margin: 0 auto;
}
.flex {
  display: flex;
  align-items: center;
}
header {
  height: 0.4167rem;
  /* background: #f2f5fa; */
  box-sizing: border-box;
  background-image: url("@/static/imgs/about-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-size: 0.1719rem;
  color: #000000;
}
.title img {
  width: 0.25rem;
  height: 0.25rem;
  margin-right: 0.0313rem;
}
.tabs {
  font-size: 0.0938rem;
  font-family: "PingFangBold";
}
.el-tabs__active-bar {
  height: 0.0208rem !important;
}
.el-tabs__header {
  margin-bottom: 0 !important;
  height: 0.4167rem !important;
}
.el-tabs__item {
  height: 0.4167rem !important;
  font-size: 0.0938rem !important;
}
/* 去掉tabs标签栏下的下划线 */
.el-tabs__nav-wrap::after {
  position: static !important;
}
/* 下划线切换高亮 */
.el-tabs__active-bar {
  background-color: #e5432c !important;
}
/* 鼠标选中时样式 */
.el-tabs__item.is-active {
  color: #e5432c !important;
  opacity: 1;
}
/* 鼠标悬浮时样式 */
.el-tabs__item:hover {
  color: #e5432c !important;
  cursor: pointer !important;
  opacity: 1;
}
</style>
